/**
 * In-page sections for the single-page layout (IDs must match DOM `id` attributes).
 */
export const NAV_SECTIONS = [
  { href: "#top", id: "top", label: "Home" },
  { href: "#about", id: "about", label: "About" },
  { href: "#projects", id: "projects", label: "Projects" },
  { href: "#ContactPage", id: "ContactPage", label: "Contact" },
];
